import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class UsersService {

	private baseUrl = environment.baseUrl + "/user";

	constructor(public http: HttpClient) {
	}

	create(requestModel): Observable<any> {
		return this.http.post(this.baseUrl + "/create", requestModel);
	};

	update(requestModel): Observable<any> {
		return this.http.post(this.baseUrl + "/update", requestModel);
	};

	resetPassword(requestModel): Observable<any> {
		return this.http.post(this.baseUrl + "/reset-password", requestModel);
	};

	changeCurrentUserPassword(requestModel): Observable<any> {
		return this.http.post(this.baseUrl + "/change-current-password", requestModel);
	};

	requestPasswordRecoveryToken(requestModel): Observable<any> {
		return this.http.post(this.baseUrl + "/request-password-recovery-token", requestModel);
	};

	recoverUserPasswordByToken(requestModel): Observable<any> {
		return this.http.post(this.baseUrl + "/recover-user-password-by-token", requestModel);
	};

	delete(requestModel): Observable<any> {
		return this.http.post(this.baseUrl + "/delete", requestModel);
	};

	get(id: number): Observable<any> {
		return this.http.get(this.baseUrl + "/" + id);
	};

	list(filterModel): Observable<any> {
		return this.http.post(this.baseUrl + "/list", filterModel);
	};
}
